/* ---------- Sticky-Kaufleiste auf der Produktseite ---------- */
(function(){
'use strict';
var bar=document.querySelector('[data-psticky]'),atc=document.querySelector('[data-atc]');
if(!bar||!atc)return;
var sbtn=bar.querySelector('[data-sticky-atc]'),sprice=bar.querySelector('[data-sticky-price]');
function show(on){bar.classList.toggle('on',on);bar.setAttribute('aria-hidden',on?'false':'true');if(sbtn)sbtn.tabIndex=on?0:-1}
if('IntersectionObserver' in window){
  new IntersectionObserver(function(es){es.forEach(function(e){show(!e.isIntersecting&&e.boundingClientRect.top<0)})},{threshold:0}).observe(atc);
}
function sync(){
  if(sbtn){sbtn.disabled=atc.disabled;sbtn.textContent=atc.textContent}
  var p=document.querySelector('[data-product] [data-price] b:last-of-type');if(p&&sprice)sprice.textContent=p.textContent;
}
new MutationObserver(sync).observe(atc,{attributes:true,childList:true,characterData:true,subtree:true});
var pr=document.querySelector('[data-product] [data-price]');if(pr)new MutationObserver(sync).observe(pr,{childList:true,subtree:true});
if(sbtn)sbtn.addEventListener('click',function(){atc.click()});
})();
